<div fxLayout="row wrap">
  <div fxFlex="100">
    <mat-card>
      <mat-card-content>
        <div fxLayout="row wrap" fxLayoutAlign="space-between center">
          <h3>Assessment Response</h3>
        </div>
        <mat-accordion class="accordion" *ngIf="allSurveys.length">
          <mat-expansion-panel *ngFor="let survey of allSurveys" @fadeIn (afterExpand)="onSurveyExpand(survey)"
            (closed)="onSurveyPanelClosed(survey)" [expanded]="survey.isExpand">
            <mat-expansion-panel-header>
              <mat-panel-title class="panel-title">
                <div class="expansion-panel-title">{{survey.title}}</div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <mat-progress-bar mode="indeterminate" color="accent" *ngIf="showLoader"></mat-progress-bar>
              <mat-accordion class="accordion">
                <mat-expansion-panel *ngFor="let response of survey.responses; let i=index;" @fadeIn
                  (afterExpand)="onResponseExpand(response)" (closed)="onResponsePanelClosed(response)"
                  [expanded]="response.isExpand">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="panel-title">
                      <div class="expansion-panel-title">Response {{i+1}}</div>
                      <label fxLayout="row" class="text-muted m-l-30">
                        <div class="m-r-20" fxLayoutAlign="start center">
                          <mat-icon class="m-r-5">calendar_today</mat-icon>
                          <span>{{response.createdOn | date :'MM-DD-YYYY hh:mm A'}}</span>
                        </div>
                        <div fxLayoutAlign="start center" *ngIf="response.score">
                          <mat-icon class="m-r-5">score</mat-icon>
                          <span>{{response.score}}</span>
                        </div>
                      </label>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <ng-template matExpansionPanelContent>
                    <mat-progress-bar mode="indeterminate" color="accent" *ngIf="showLoader"></mat-progress-bar>
                    <div *ngIf="response.hiddenFields&&response.hiddenFields.length">
                      <div class="que-style"><b>Automatically generated data</b></div>
                      <div class="m-t-15" fxLayout="row wrap" *ngFor="let item of response.hiddenFields;">
                        <span class="hidden-field-key">{{item[0]}}: </span>
                        <span class="hidden-field-value text-muted">{{item[1]}}</span>
                      </div>
                    </div>
                    <div class="m-t-15" fxLayout="row wrap" *ngFor="let item of response.questionnaire; let j=index">
                      <div *ngIf="item.type!=='display'" class="que-style">Q{{j+1}}. {{item.text}}</div>
                      <div *ngIf="item.answer&&item.answer.length">
                        <div class="ans-style text-muted" *ngIf="item.type==='boolean'">{{item.answer[0]}}</div>
                        <div class="ans-style text-muted"
                          *ngIf="item.type==='string' || item.type==='text' || item.type==='date' || item.type==='time' || item.type==='dateTime' || item.type==='url' || item.type==='decimal'">
                          <span *ngIf="item.answer.length === 1" [innerHTML]="item.answer[0]"></span>
                          <span *ngIf="item.answer.length>1">
                            <div *ngFor="let item of item.answer"><span [innerHTML]="item"></span></div>
                          </span>
                        </div>
                        <div class="ans-style text-muted" *ngIf="item.type==='choice'">
                          <div *ngIf="item.answer.length>1">
                            <li *ngFor="let item of item.answer">{{item}}</li>
                          </div>
                          <div *ngIf="item.answer.length === 1">
                            {{item.answer[0]}}
                          </div>
                        </div>
                        <div class="ans-style" *ngIf="item.type==='attachment' || (item.type==='reference'&&!item.intent)">
                          <button type="button" mat-raised-button color="primary"
                            (click)="downloadDocs(item.answer[0])">
                            <mat-icon>get_app</mat-icon>Download
                          </button>
                        </div>
                        <div class="ans-style" *ngIf="item.type==='reference' && item.src">
                          <img [src]="transform(item.src)">
                        </div> 
                      </div>
                    </div>
                  </ng-template>
                </mat-expansion-panel>
              </mat-accordion>
            </ng-template>
          </mat-expansion-panel>
        </mat-accordion>
        <div *ngIf="!allSurveys.length">
          <h3>No survey available</h3>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>